module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABb0lEQVQ4T6WTMU4DMRBF/6xzgCBRIkFBTwp6rKzT5wh7hKVHSjgB4QbJDUIdO3JJGU5ACg6QA+zOoInWSOyibCTcWJY9b/6fGRP+uagdb60dGmNeAFgiugDwKSKLEMLqr1wdgHMuisi+rusyxniYTCYjZl4DKEMIuv9aR4C19sYYMwNwC+CeiN5b7y5F5IqIdgDevPeLdH8EOOdKAEMAmr0IIRTtTKqsqqqpMSbWdT2NMe71TQLMNdh7H/tqmiymJB1A41lVlHmea/FKVZhkK4CZPYCv7Xa77ADyPFef1wBWRPQA4KD2mPlVAxQAQBVb7/28A9BsWocsywpmXhKRnhfJdy9gPB4XRPQiIo9ENCOipQJF5PlcBXMRmWpGY8w6KVBFm81m16vAOWfVo/feaj1CCCMN0nPT8tM1aCyMsixT6VqoRerGSQAz79XjOXNQVdXTYDBwP11oRln93p0CiAh0nEXkI/2VzmfqU9C+/wZu9RYg0J0eKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team.png
// module id = +S5a
// module chunks = 1